import axios from 'axios'
import Vue from 'vue'
import store from '../store'
import router from '../router/index'
import {getAesKey, rsaEncrypt, aesEncrypt} from '../utils/crypto'
import { refreshToken} from '../api/login'
import {Modal} from "ant-design-vue";

// 401重复的标记
let loginRefreshing = false

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 20000
})

// 创建流媒体请求axios实例
const videoService = axios.create({
  baseURL: process.env.VUE_APP_VIDEO_BASE_URL,
  timeout: 10000
})

// 创建报表请求axios实例
const reportService = axios.create({
  baseURL: process.env.VUE_APP_REPORT_BASE_URL,
  timeout: 60000
})

// 创建AI机器人回复请求axios实例
const robotService = axios.create({
  baseURL: process.env.VUE_APP_AI_BASE_URL,
  timeout: 10000
})
const getRecursionCode = function (item,tabName) {
  let code = "";
  if(tabName === item.title){
    return item.key;
  } else {
    //有子菜单
    if(item.children !== undefined){
      for (let y = 0; y < item.children.length; y++) {
        const itemChildren = item.children[y];
        code = getRecursionCode(itemChildren,tabName);
        if(code !==""){
          return code;
        }
      }
    }
  }
  return code;
}
const getMenuCode = function (menusArray, tabName) {
  let code = "";
  for (let x = 0; x < menusArray.length; x++) {
    const item = menusArray[x];
    code = getRecursionCode(item,tabName)
    if(code !==""){
      return code;
    }
  }
  return code;
}
const getTableName = function (tabs,activeTab) {
  let tabName = "";
  for (let x = 0; x < tabs.length; x++) {
    const item = tabs[x];
    if(item.path === activeTab){
      return item.name;
    }
  }
  return tabName;
}
const activeTabTemp = [];
service.interceptors.request.use(req => {
  const token = Vue.ss.get('token')
  if (token) {
    req.headers['token'] = token
  }
  let tabs = store.getters.tabs;
  let activeTab = store.getters.activeTab;

  let menusArray = store.getters.menus;
  let tabName = getTableName(tabs,activeTab);
  let menucode = getMenuCode(menusArray, tabName);
  if(menucode === ""){
    menucode = store.getters.currentMenuCode
    if(menucode === ""){
      menucode = Vue.ss.get('menucode')
    }
  }

  if (menucode && menucode !== '') {
    req.params = Object.assign({}, req.params ? req.params : {}, {'menucode': menucode})
  }

  if (process.env.NODE_ENV === 'production') {
    const key = Vue.ss.get('rsaPublicKey')
    if (key) {
      if (req.data) {
        req.headers['key1'] = key

        const aesKey = getAesKey()
        req.headers['key2'] = rsaEncrypt(aesKey, key)
        req.data = aesEncrypt(JSON.stringify(req.data), aesKey)
      }
    }
  }

  return req
})

service.interceptors.response.use(res => {
  const t = res.data
  if (t.success) {
    return t.data
  } else {
    return Promise.reject(t)
  }
},function(err){
  const status = err.response.status;
  const desc = err.response.data.desc;
  let msg = '';
  if (status === 401) {
    if (!loginRefreshing) {
      loginRefreshing = true
      //判断是否存在刷新token
      if(Vue.ss.get('refresh_token')){
        return refreshToken(Vue.ss.get('refresh_token')).then(d => {
          loginRefreshing = false
          Vue.ss.set('token', d.access_token, d.expires_in * 1000)
          Vue.ss.set('refresh_token', d.refresh_token, 3600 * 24 * 1000)
          let config = err.config
          config.headers.token = d.access_token
          const res_new = service.request(config)
          return res_new
        }).catch(err => {
          Vue.ss.remove('token')
          Vue.ss.remove('refresh_token')
          Modal.info({
            title: '温馨提示',
            content: '您当前的登录状态已失效，请重新登录。',
            onOk() {
              store.dispatch('Logout').then(() => {
                loginRefreshing = false
                router.push('/login');
              })
            }
          });
        });
      }else{
        // 认证失败
        Vue.ss.remove('token');
        console.error(`认证失败，系统返回：${err.response.data}`);
        msg = '您当前的登录状态已失效，请重新登录本系统。';
        Modal.info({
          title: '温馨提示',
          content: msg,
          onOk() {
            store.dispatch('Logout').then(() => {
              // router.push('/login');
              loginRefreshing = false
              router.push('/login');
            })
          }
        });
      }
    }
  }else if(status === 403){
    Modal.info({
      title: '权限控制',
      content: t.desc?t.desc:'您当前登录账户权限不足。',
      onOk() {

      }
    });
  }else if(status === 409){
    msg = '您当前登录账户已在其他客户端登录，您将强制下线，可在该客户端重新登录。';
    Modal.info({
      title: '温馨提示',
      content: msg,
      onOk() {
        store.dispatch('Logout').then(() => {
          router.push('/login');
        })
      }
    });
  } else if(status === 500){
    Modal.info({
      title: '温馨提示',
      content: desc?desc:'当前操作失败，请稍后重试。',
      onOk() {

      }
    });
    return Promise.reject(err)
  }else if(status === 404){
    Modal.info({
      title: '资源不存在',
      content: desc?desc:'当前资源不存在，请稍后重试。',
      onOk() {
      }
    });
  }
})

const installer = {
  vm: {},
  install(Vue) {
    Vue.axios = service
    Object.defineProperties(Vue.prototype, {
      axios: {
        get: function get() {
          return service
        }
      },
      $http: {
        get: function get() {
          return service
        }
      }
    })
  }
}

export {
  installer as VueAxios,
  service as axios,
  videoService as video,
  robotService as robot
}
